import {Component, inject, signal, WritableSignal} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Community} from '../../classes/community';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {MatCardModule} from '@angular/material/card';

import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {FileUploadComponent} from '../../modals/file-upload/file-upload.component';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {filter, of} from 'rxjs';
import {MatSnackBar} from '@angular/material/snack-bar';
import { SNACKBAR_DURATION } from '../../../../shared/constants/snackbar.constants';
import {UploadedFile} from '../../../../core/classes/uploaded-file';
import {GenCommunityMember} from '../../../../generated/serverModels/GenCommunityMember';
import {GenMemberRole} from '../../../../generated/serverModels/GenMemberRole';
import {MatMenuModule} from '@angular/material/menu';
import {CommunityService} from '../../../../services/community.service';

@Component({
    selector: 'tgrid-community',
    imports: [
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
],
    templateUrl: './community.component.html',
    styleUrl: './community.component.scss',
})
export class CommunityComponent {
  public activatedRoute = inject(ActivatedRoute);
  public communityService = inject(CommunityService);
  private dialog = inject(MatDialog);
  public snackBar = inject(MatSnackBar);

  public community: Community;
  public isManager: boolean;

  public managers: WritableSignal<GenCommunityMember[]> = signal([]);

  constructor() {

    // Can we make a signal out of this?
    this.activatedRoute.data
      .pipe(takeUntilDestroyed())
      .subscribe(({community, isManager}) => {
        this.community = community;
        this.isManager = isManager;
        this.managers.set(this.community.members.filter(member => member.role === GenMemberRole.MANAGER));
      });
  }


  public openFileUploadModal() {
    const config: MatDialogConfig = {
      disableClose: true,
      width: '500px',
      data: {
        communities: of([this.community]),
      },
    };


    this.dialog.open(FileUploadComponent, config).afterClosed()
      .pipe(
        filter(uploadedFiles => !!uploadedFiles),
      )
      .subscribe((files: UploadedFile[]) => {
        this.snackBar.open('Successfully uploaded files', 'X', {duration: SNACKBAR_DURATION.LONG, panelClass: 'snackbar-success'});
        this.community.files.push(...files);
      });
  }

  // Removing until we get a larger user list to add from
  // public addMember() {
  //   alert('Not yet implemented');
  // }


  public removeFromCommunity(member: GenCommunityMember) {
    this.communityService.removeUserFromCommunity(this.community, member).subscribe(
      {
        next: () => {
          this.snackBar.open(`Removed ${member.firstName} ${member.lastName}`, 'X', {
            duration: SNACKBAR_DURATION.LONG,
            panelClass: 'snackbar-success',
          });
        },
        error: (error: Error) => {
          console.error(error);
          this.snackBar.open(`Unable to remove ${member.firstName} ${member.lastName} from community`, 'X', {
            duration: SNACKBAR_DURATION.LONG,
            panelClass: 'snackbar-failure',
          });
        },
      },
    );
  }

  public promoteToManager(member: GenCommunityMember) {
    this.communityService.changeUserRole(this.community, member, GenMemberRole.MANAGER).subscribe(
      {
        next: () => {
          //TODO: this might be a good place to look at adding NGRX or signals after the first demo
          const  index = this.community.members.findIndex(cm => cm.userId === member.userId);
          this.community.members.splice(index, 1);
          this.snackBar.open(`Set ${member.firstName} ${member.lastName} to a community manager`, 'X', {
            duration: SNACKBAR_DURATION.LONG,
            panelClass: 'snackbar-success',
          });
        },
        error: (error: Error) => {
          console.error(error);
          this.snackBar.open(`Unable to set ${member.firstName} ${member.lastName} to a community manager`, 'X', {
            duration: SNACKBAR_DURATION.LONG,
            panelClass: 'snackbar-failure',
          });
        },
      },
    );
  }
}
